import React from 'react'
import { Outlet } from 'react-router-dom'

import './AuthLayout.css'

const AuthLayout = () => <Outlet />

export default AuthLayout
